import React, { useState, useEffect } from 'react';
import { Spin, Tooltip, message, Popconfirm } from 'antd';
import moment from 'moment';

import { postCancelarSolicitacao } from '../../../services';
import { useAuth } from '../../../hooks/auth';

import {
  returnCorStatusSolicitacaoText,
  returnStatusSolicitacaoLabel,
} from '../utils';

import * as S from './styles';

export function TabelaListagem({
  recarregar = () => { },
  openModal = () => { },
  pageProps = () => { },
  dataSource = [],
  loading = false,
}) {
  const { temPermissao } = useAuth();
  const [listaSolicitacao, setListaSolicitacao] = useState([]);
  const [columnsTable, setColumnsTable] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });
  const columns = [
    {
      title: '',
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      render: (_, record, index) => (
        <S.ButtonVerSolicitacao key={index} onClick={() => openModal(record)}>
          Ver Solicitação
        </S.ButtonVerSolicitacao>
      ),
    },
    {
      title: 'Usuário',
      dataIndex: 'usuario',
      key: 'usuario',
      align: 'center',
    },
    {
      title: 'Data de Inclusão',
      dataIndex: 'dataInclusao',
      key: 'dataInclusao',
      align: 'center',
    },
    {
      title: 'Solicitação',
      dataIndex: 'solicitacao',
      key: 'solicitacao',
      align: 'center',
    },
    {
      title: 'Matriz de Consulta',
      dataIndex: 'nomeMatriz',
      key: 'nomeMatriz',
      align: 'center',
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      align: 'center',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (_, record, index) => (
        <S.LabelStatus
          key={index}
          cor={returnCorStatusSolicitacaoText(record?.status)}
        >
          {returnStatusSolicitacaoLabel(record?.status) || '-'}
        </S.LabelStatus>
      ),
    },
    {
      title: '',
      dataIndex: 'cancelar',
      key: 'cancelar',
      align: 'center',
      render: (_, record, index) =>
        record?.data?.idStatusSolicitacao === 1 && (
          <Tooltip title="Cancelar a solicitação." placement="topRight">
            <Popconfirm
              key={index}
              title={`Deseja Cancelar a solicitação ${record?.data
                ?.idIntegracao || ''}?`}
              cancelText="Não"
              okText="Sim"
              placement="bottomRight"
              onConfirm={() => handlerCancelarSolicitacao(record)}
            >
              <S.BtnCancelar />
            </Popconfirm>
          </Tooltip>
        ),
    },
  ];

  const handlerCancelarSolicitacao = async data => {
    const idSolicitacao = data?.data?.idSolicitacao || null;
    const responseSucesso = (data = '') => {
      recarregar();
      return message.success(data || 'Solicitação cancelada com sucesso!');
    };

    const responseErro = (data = '') => message.error(data || 'Erro ao cancelar a solicitação!');

    if (idSolicitacao) {
      const response = await postCancelarSolicitacao({ idSolicitacao });
      return response?.status === 200
        ? responseSucesso(response?.data)
        : responseErro(response?.data?.response?.data);
    }
  };

  const handlerPager = data => {
    pageProps(data);
  };

  const formatarTable = data => {
    setPagination({
      current: data?.data?.pageIndex || 1,
      pageSize: 15,
      total: data?.data?.count || 0,
    });
    const tabeList = data?.data?.items?.map(item => ({
      usuario: item?.nome || '-',
      dataInclusao:
        (item?.dataSolicitacao &&
          moment(item?.dataSolicitacao).format('DD/MM/YYYY [às] HH:mm:ss')) ||
        '-',
      solicitacao: item?.idIntegracao || '-',
      nomeMatriz: item?.matrizNome || '-',
      cliente: item?.nomeFantasia || '-',
      status: item?.descricaoStatus || '-',
      data: item,
    }));
    return setListaSolicitacao(tabeList);
  };

  useEffect(() => {
    formatarTable(dataSource || []);
  }, [dataSource]);

  useEffect(() => {
    const permissao = temPermissao(['CancelarAnaliseSolicitacao']);
    setColumnsTable(
      permissao
        ? columns
        : columns?.filter(item => item.dataIndex !== 'cancelar')
    );
  }, [temPermissao, recarregar]);

  return (
    <>
      <Spin
        spinning={loading}
        size="large"
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
      {listaSolicitacao?.length > 0 && (
        <S.TabelaFiltrada
          aria-label="tabela-listagem"
          columns={columnsTable}
          dataSource={listaSolicitacao}
          pagination={{
            ...pagination,
            showTotal: total =>
              `Total de ${total} ${total > 1 ? 'itens' : 'item'}`,
            showQuickJumper: false,
            showSizeChanger: false,
          }}
          onChange={handlerPager}
        />
      )}
      {listaSolicitacao?.length === 0 && (
        <S.TituleContainernotData>
          <S.TituleBoxnotData>
            <S.TituleNotData>
              Nenhuma solicitação encontrada. Verifique os filtros preenchidos.
            </S.TituleNotData>
          </S.TituleBoxnotData>
        </S.TituleContainernotData>
      )}
    </>
  );
}
